// const baseUrl = 'http://192.168.1.66:9091'
// const baseUrl = 'http://192.168.0.6:9091'
// const baseUrl = 'http://192.168.0.8:9091'
// const baseUrl = 'http://localhost:8080'
// const baseUrl = 'http://192.168.10.64:9091'
// const baseUrl = 'http://localhost:9091'
// const baseUrl = 'http://192.168.10.64:9091'
// const baseUrl = 'http://localhost:9091'
// const baseUrl = 'http://192.168.1.69:90npn91'
// const baseUrl = 'http://192.168.10.64:9091'
// const baseUrl = 'http://192.168.1.152:9091'
// This if for Dev
// const baseUrl = 'http://38.242.128.33:8080'
// This if for production
const baseUrl = 'http://api.ecalculo.com'
export default baseUrl



// WEBPACK FOOTER //
// ./src/store/globalKey.js